import { useEffect } from 'react';
import { useInvoiceDetailDrawerStore } from '../../stores/invoice-detail-drawer-store';
import { InvoiceDetailView } from './InvoiceDetailView';

/**
 * Overlay-drawer voor Invoice__c detail. Globaal gemount in AppLayout.
 *
 * Stacking: z-[70] overlay + z-[80] aside — opzettelijk boven
 * OrderDetailDrawerPanel (z-[55]/z-[60]) en de modals/drawers die vanuit
 * order-drawer worden geopend (z-[65]/z-[70]). Zo kan kantoor vanuit
 * order-drawer → factuur-drawer klikken en stacken ze correct.
 */
export function InvoiceDetailDrawerPanel() {
  const openInvoiceId = useInvoiceDetailDrawerStore((s) => s.openInvoiceId);
  const close = useInvoiceDetailDrawerStore((s) => s.close);

  useEffect(() => {
    if (!openInvoiceId) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      const t = e.target as HTMLElement | null;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT')) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      close();
    };
    window.addEventListener('keydown', handler, true);
    return () => window.removeEventListener('keydown', handler, true);
  }, [openInvoiceId, close]);

  if (!openInvoiceId) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-slate-900/30 z-[70]"
        onClick={close}
        aria-hidden
      />
      <aside
        className="fixed top-0 right-0 h-full w-full max-w-2xl bg-white shadow-2xl z-[80] flex flex-col"
        role="dialog"
        aria-modal="true"
        aria-label="Factuur detail"
      >
        <InvoiceDetailView
          key={openInvoiceId}
          invoiceId={openInvoiceId}
          variant="drawer"
          onClose={close}
        />
      </aside>
    </>
  );
}
